import store from '@/store';
import Vue from 'vue';
import VueRouter, { RouteConfig } from 'vue-router';

Vue.use(VueRouter);

const routes: RouteConfig[] = [
    // 認証画面
    {
        path: '/',
        name: 'authentication',
        component: () => import('@/views/authentication/saml-authentication.vue')
    },
    // 認証エラー画面
    {
        path: '/authentication-error',
        name: 'authentication-error',
        component: () => import('@/views/authentication/saml-authentication-error.vue')
    },
    // ユーザー一覧画面
    {
        path: '/users/list',
        name: 'user-list',
        component: () => import('@/views/users/user-list.view.vue')
    },
    // ユーザー登録画面
    {
        path: '/users/add',
        name: 'user-add',
        component: () => import('@/views/users/user-add.view.vue')
    },
    // ユーザー編集画面
    {
        path: '/users/edit/:id',
        name: 'user-edit',
        component: () => import('@/views/users/user-add.view.vue')
    },
    // ユーザー削除画面
    {
        path: '/users/delete/:id',
        name: 'user-delete',
        component: () => import('@/views/users/user-delete.view.vue')
    },
    // ユーザー管理(一括登録)：ファイル選択画面
    {
        path: '/bulk-add-users/upload',
        name: 'bulk-add-users-upload',
        component: () => import('@/views/bulk-add-users/bulk-add-users-upload.view.vue')
    },
    // ユーザー管理(一括登録)：エラーチェック結果
    {
        path: '/bulk-add-users/result',
        name: 'bulk-add-users-result',
        component: () => import('@/views/bulk-add-users/bulk-add-users-result.view.vue')
    },
    // ユーザー管理(一括登録)：登録完了
    {
        path: '/bulk-add-users/complete',
        name: 'bulk-add-users-complete',
        component: () => import('@/views/bulk-add-users/bulk-add-users-complete.view.vue')
    },
    // 処理依頼応答：処理依頼一覧画面
    {
        path: '/processing-requests/list',
        name: 'processing-requests-list',
        component: () => import('@/views/processing-requests/processing-requests-list.view.vue')
    },
    // 処理依頼応答：処理依頼確認画面
    {
        path: '/processing-requests/confirmation/:processRequestId',
        name: 'processing-requests-confirmation',
        component: () => import('@/views/processing-requests/processing-requests-confirmation.view.vue')
    },
    // ユーザー管理：処理状況
    {
        path: '/processing-status-users/list',
        name: 'processing-status-users-list',
        component: () => import('@/views/processing-status-users/processing-status-users-list.view.vue')
    },
    // ユーザー管理：処理状況(詳細画面)
    {
        path: '/processing-status-users/detail/:processId',
        name: 'processing-status-users-detail',
        component: () => import('@/views/processing-status-users/processing-status-users-detail.view.vue')
    },
    // 組織一覧画面
    {
        path: '/organizations/list',
        name: 'organization-list',
        component: () => import('@/views/organizations/organization-list.view.vue')
    },
    // 組織登録画面
    {
        path: '/organizations/add',
        name: 'organization-add',
        component: () => import('@/views/organizations/organization-add.view.vue')
    },
    // 組織編集画面
    {
        path: '/organizations/edit/:id',
        name: 'organization-edit',
        component: () => import('@/views/organizations/organization-add.view.vue')
    },
    // 組織削除画面
    {
        path: '/organizations/delete/:id',
        name: 'organization-delete',
        component: () => import('@/views/organizations/organization-delete.view.vue')
    },
    // 組織管理：処理状況
    {
        path: '/processing-status-organizations/list',
        name: 'processing-status-organizations-list',
        component: () => import('@/views/processing-status-organizations/processing-status-organizations-list.view.vue')
    },
    // 組織管理：処理状況(詳細画面)
    {
        path: '/processing-status-organizations/detail/:coverage',
        name: 'processing-status-organizations-detail',
        component: () => import('@/views/processing-status-organizations/processing-status-organizations-detail.view.vue')
    },
    // パラメータ管理
    {
        path: '/parameter-settings',
        name: 'parameter-settings',
        component: () => import('@/views/parameters/parameter-settings.view.vue')
    },
    // 年度更新：所属コード変換
    {
        path: '/fiscal-year-update/affiliation-code-conversion',
        name: 'fiscal-year-update-affiliation-code-conversion',
        component: () => import('@/views/affiliation-code-conversion/affiliation-code-conversion.view.vue')
    },
    // 年度更新：人事異動データアップロード
    {
        path: '/fiscal-year-update/personnel-change/upload',
        name: 'fiscal-year-update-personnel-change-upload',
        component: () => import('@/views/personnel-change/personnel-change-upload.view.vue')
    },
    // 年度更新：人事異動データチェック結果確認
    {
        path: '/fiscal-year-update/personnel-change/result',
        name: 'fiscal-year-update-personnel-change-result',
        component: () => import('@/views/personnel-change/personnel-change-result.view.vue')
    },
    // 年度更新：人事異動データダウンロード
    {
        path: '/fiscal-year-update/personnel-change/download',
        name: 'fiscal-year-update-personnel-change-download',
        component: () => import('@/views/personnel-change/personnel-change-download.view.vue')
    },
    // 年度更新：通知データ作成-ファイル選択
    {
        path: '/fiscal-year-update/notification-data/upload',
        name: 'fiscal-year-update-notification-data-upload',
        component: () => import('@/views/notification-data/notification-data-upload.view.vue')
    },
    // 年度更新：通知データ作成-処理結果確認
    {
        path: '/fiscal-year-update/notification-data/result',
        name: 'fiscal-year-update-notification-data-result',
        component: () => import('@/views/notification-data/notification-data-result.view.vue')
    },
    // 年度更新：通知データ作成-ダウンロード
    {
        path: '/fiscal-year-update/notification-data/download',
        name: 'fiscal-year-update-notification-data-download',
        component: () => import('@/views/notification-data/notification-data-download.view.vue')
    },
    // エラー画面
    {
        path: '/error',
        name: 'error',
        component: () => import('@/views/common/common-error.view.vue')
    },
    // 404エラー画面（存在しないURLが指定された時のページ）
    {
        path: '*',
        name: 'notFound',
        component: () => import('@/views/common/common-not-found.view.vue')
    }
];

const vueRouter = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
});

/**
 * ストアのステートクリア処理
 * 
 * @param to 画面遷移先情報
 * @param from 画面遷移元情報
 */
function clearStoreState(to: any, from: any): void {
    switch (to.name) {
        case 'user-list':                                           // ユーザー一覧
            clearStoreStateUser(from);                              // ユーザー管理ストアのクリア
            break;
        case 'processing-status-users-list':                        // ユーザー処理状況一覧
            clearStoreStateProcessingStatusUsers(from);             // ユーザー処理状況管理ストアのクリア
            break;
        case 'organization-list':                                   // 組織一覧
            clearStoreStateOrganization(from);                      // 組織一覧管理ストアのクリア
            break;
        case 'processing-status-organizations-list':                // 組織処理状況一覧
            clearStoreStateProcessingStatusOrganizations(from);     // 組織処理状況一覧管理ストアのクリア
            break;
        case 'processing-requests-list':                            // 処理依頼一覧
            clearStoreStateProcessingRequests(from);                // 処理依頼管理ストアのクリア
            break;
    }
}

/**
 * 画面遷移元情報の保存処理
 * 
 * @param from 画面遷移元情報
 */
function saveDisplayPath(from: any): void {
    store.commit('resetBeforeDisplayPath');                         // 画面遷移元のパスをクリア
    store.commit('setBeforeDisplayPath', from.path);                // 画面遷移元のパスの保存
}

/**
 * ユーザー管理ストアのクリア処理
 * ユーザー管理の一覧画面に、登録、編集、削除画面以外から
 * 遷移してきた場合にユーザー管理のストアで保持しているステート情報をクリアする
 * F5による再描画もfrom.nameがnullになるためクリア対象とします。
 * 
 * @param from 画面遷移元情報
 */
function clearStoreStateUser(from: any): void {
    // ストアクリア対象外の画面遷移元ルート名
    const doNotClearFromName = ['user-add', 'user-edit', 'user-delete'];

    // クリア対象か判定（doNotClearFromNameに存在しないルート名はクリア対象）
    if (doNotClearFromName.indexOf(from.name) === -1) {
        store.commit('user/clearStoreState');
    } else {
        // 登録・編集・削除画面からの遷移の場合、遷移フラグにtrueを設定
        // フィルタを復元した際にページ番号が1へ戻らないようにするため
        store.commit('user/setIsFromAdd', true);
    }
}

/**
 * ユーザー処理状況管理ストアのクリア処理
 * ユーザー処理状況管理一覧画面に、処理状況詳細画面以外から
 * 遷移してきた場合にユーザー処理状況管理のストアで保持しているステート情報をクリアする
 * F5による再描画もfrom.nameがnullになるためクリア対象とします。
 * 
 * @param from 画面遷移元情報
 */
function clearStoreStateProcessingStatusUsers(from: any): void {
    // ストアクリア対象外の画面遷移元ルート名
    const doNotClearFromName = ['processing-status-users-detail',];

    // クリア対象か判定（doNotClearFromNameに存在しないルート名はクリア対象）
    if (doNotClearFromName.indexOf(from.name) === -1) {
        store.commit('processingStatusUsers/clearStoreState');
    } else {
        // 詳細画面からの遷移の場合、遷移フラグにtrueを設定
        // フィルタを復元した際にページ番号が1へ戻らないようにするため
        store.commit('processingStatusUsers/setIsFromDetail', true);
    }
}

/**
 * 組織管理ストアのクリア処理
 * 組織管理の一覧画面に、登録、編集、削除画面以外から
 * 遷移してきた場合に組織管理のストアで保持しているステート情報をクリアする
 * F5による再描画もfrom.nameがnullになるためクリア対象とします。
 * 
 * @param from 画面遷移元情報
 */
function clearStoreStateOrganization(from: any): void {
    // ストアクリア対象外の画面遷移元ルート名
    const doNotClearFromName = ['organization-add', 'organization-edit', 'organization-delete'];

    // クリア対象か判定（doNotClearFromNameに存在しないルート名はクリア対象）
    if (doNotClearFromName.indexOf(from.name) === -1) {
        store.commit('organization/clearStoreState');
    } else {
        // 登録・編集・削除画面からの遷移の場合、遷移フラグにtrueを設定
        // フィルタを復元した際にページ番号が1へ戻らないようにするため
        store.commit('organization/setIsFromAdd', true);
    }
}

/**
 * 組織処理状況管理ストアのクリア処理
 * 組織処理状況一覧画面に、組織処理状況詳細画面以外から
 * 遷移してきた場合に組織処理状況管理ストアで保持しているステート情報をクリアする
 * 処理依頼管理ストアのクリア処理
 * 処理依頼管理一覧画面に、処理依頼確認画面以外から
 * 遷移してきた場合に処理依頼管理のストアで保持しているステート情報をクリアする
 * F5による再描画もfrom.nameがnullになるためクリア対象とします。
 * 
 * @param from 画面遷移元情報
 */
function clearStoreStateProcessingStatusOrganizations(from: any): void {
    // ストアクリア対象外の画面遷移元ルート名
    const doNotClearFromName = ['processing-status-organizations-detail',];

    // クリア対象か判定（doNotClearFromNameに存在しないルート名はクリア対象）
    if (doNotClearFromName.indexOf(from.name) === -1) {
        store.commit('processingStatusOrganizations/clearStoreState');
    } else {
        // 詳細画面からの遷移の場合、遷移フラグにtrueを設定
        // フィルタを復元した際にページ番号が1へ戻らないようにするため
        store.commit('processingStatusOrganizations/setIsFromDetail', true);
    }
}

/**
 * 処理依頼管理ストアのクリア処理
 * 処理依頼管理一覧画面に、処理依頼確認画面以外から
 * 遷移してきた場合に処理依頼管理のストアで保持しているステート情報をクリアする
 * F5による再描画もfrom.nameがnullになるためクリア対象とします。
 * 
 * @param from 画面遷移元情報
 */
function clearStoreStateProcessingRequests(from: any): void {
    // ストアクリア対象外の画面遷移元ルート名
    const doNotClearFromName = ['processing-requests-confirmation',];

    // クリア対象か判定（doNotClearFromNameに存在しないルート名はクリア対象）
    if (doNotClearFromName.indexOf(from.name) === -1) {
        store.commit('processingRequests/clearStoreState');
    } else {
        // 確認画面からの遷移の場合、遷移フラグにtrueを設定
        // フィルタを復元した際にページ番号が1へ戻らないようにするため
        store.commit('processingRequests/setIsFromConfirm', true);
    }

}

/**
 * アクセスログ出力フラグの切り替え
 * 
 * @param to 画面遷移先情報
 * @param from 画面遷移元情報
 */
 function switchAccessLog(to: any, from: any): void {
    /** アクセスログを出力しない画面名 */
    const notOutputAccessLog = [
        'authentication',
        'error',
        'notFound',
        'authentication-error'
    ];

    /** パスにIDが存在する画面（詳細・編集・削除） */
    const getPathDisplay = [
        'user-edit',
        'user-delete',
        'organization-edit',
        'organization-delete',
        'processing-status-users-detail',
        'processing-status-organizations-detail',
        'processing-requests-confirmation'
    ];

    /** ユーザー一覧からの画面遷移で再度一覧に遷移した際にログをスキップする画面 */
    const userSkipDisplay = [
        'user-add',
        'user-edit',
        'user-delete'
    ];

    /** 組織一覧からの画面遷移で再度一覧に遷移した際にログをスキップする画面 */
    const organizationSkipDisplay = [
        'organization-add',
        'organization-edit',
        'organization-delete'
    ];

    // ユーザー 登録、編集、削除画面から 一覧画面へ遷移した場合、一覧画面ではログを出力しない
    if (userSkipDisplay.indexOf(from.name) !== -1 && to.name === 'user-list'
    ) {
        return;
    }

    // ユーザー 一括登録 step2からstep1へ遷移した場合、step1ではログを出力しない
    if (from.name === 'bulk-add-users-result' && to.name === 'bulk-add-users-upload'
    ) {
        return;
    }

    // ユーザー 一括登録 step3からstep1へ遷移した場合、step1ではログを出力しない
    if (from.name === 'bulk-add-users-complete' && to.name === 'bulk-add-users-upload'
    ) {
        return;
    }

    // ユーザー 処理状況詳細画面から 処理状況一覧画面へ遷移した場合、一覧画面ではログを出力しない
    if (from.name === 'processing-status-users-detail' && to.name === 'processing-status-users-list'
    ) {
        return;
    }

    // 組織 登録、編集、削除画面から 一覧画面へ遷移した場合、一覧画面ではログを出力しない
    if (organizationSkipDisplay.indexOf(from.name) !== -1 && to.name === 'organization-list'
    ) {
        return;
    }

    // 処理依頼確認画面から 処理依頼一覧画面へ遷移した場合、一覧画面ではログを出力しない
    if (from.name === 'processing-requests-confirmation' && to.name === 'processing-requests-list'
    ) {
        return;
    }

    // 詳細、更新、削除画面等であればIDを取得
    if (getPathDisplay.indexOf(to.name) !== -1) {
        // 取得する画面の場合、IDをストアに格納
        const length = to.path.split('/').length;         // パスを分解した際の要素数
        const pathParam = to.path.split('/')[length - 1]; // パスの末尾のパラメータ

        store.commit('setLogDisplayId', pathParam);
    } else {
        // 取得しない場面の場合、nullをストアに格納
        store.commit('setLogDisplayId', null);
    }

    // アクセスログを出力しない画面の場合
    if (notOutputAccessLog.indexOf(to.name) !== -1) {
        // アクセスログ出力フラグをfalseに
        store.commit('setIsAccessLog', false);
        // 画面名に空文字をいれる
        store.commit('setDisplayName', '');
    } else {
        // アクセスログを出力する画面の場合
        // アクセスログ出力フラグをtrueに
        store.commit('setIsAccessLog', true);
        // 画面名をいれる
        store.commit('setDisplayName', to.name);
    }
}

/**
 * ストアのステートクリア処理を実行する
 * 
 * 画面遷移元のパスを保存を行う
 * 
 */
vueRouter.beforeEach((to, from, next) => {
    clearStoreState(to, from);  // ストアのステートクリア
    saveDisplayPath(from);      // 画面遷移元のパスの保存
    switchAccessLog(to, from);  // アクセスログ出力フラグの切り替え
    next();
});

export default vueRouter;
